import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../network/apis/auth';
import * as Sentry from '@sentry/react';
import { Logger } from '../utils/logger';

const AuthContext = createContext(null);

// eslint-disable-next-line no-unused-vars
const _RETRY_COUNT = 3;
// eslint-disable-next-line no-unused-vars
const _RETRY_DELAY = 1000;

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        checkAuthStatus();
    }, []);

    // const _refreshToken = async () => {
    //     try {
    //         const refresh = localStorage.getItem('refreshToken');
    //         if (!refresh) return null;

    //         const response = await authApi.refreshToken(refresh);
    //         localStorage.setItem('token', response.data.access);
    //         localStorage.setItem('refreshToken', response.data.refresh);
    //         return response.data.token;
    //     } catch (error) {
    //         Logger.error('Token refresh failed', error);
    //         throw error;
    //     }
    // };

    // const retryWithDelay = async (fn, retries = RETRY_COUNT) => {
    //     try {
    //         return await fn();
    //     } catch (error) {
    //         if (retries > 0) {
    //             await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
    //             return retryWithDelay(fn, retries - 1);
    //         }
    //         throw error;
    //     }
    // };

    const checkAuthStatus = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token || token === 'undefined') {
                setUser(null);
                setLoading(false);
                return;
            }

            // const validateAuth = async () => {
            //     try {
            //         const response = await authApi.validateToken();
            //         return response.data;
            //     } catch (error) {
            //         if (error.response?.status === 401) {
            //             const newToken = await refreshToken();
            //             if (newToken) {
            //                 const response = await authApi.validateToken();
            //                 return response.data;
            //             }
            //         }
            //         throw error;
            //     }
            // };

            // const userData = await retryWithDelay(validateAuth);
            // setUser(userData.user);
            const userData = JSON.parse(localStorage.getItem('user'));
            console.log(userData);
            setUser(userData);
            setIsAuthenticated(true);
            setError(null);
        } catch (error) {
            Logger.error('Auth check failed', error);
            Sentry.captureException(error);
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            setUser(null);
            setIsAuthenticated(false);
            setError('Authentication failed');
        } finally {
            setLoading(false);
        }
    };

    const login = async (credentials) => {
        try {
            setLoading(true);
            const response = await authApi.login(credentials);
            const { access, refresh, user } = response.data;
            localStorage.setItem('refreshToken', refresh);
            localStorage.setItem('token', access);
            localStorage.setItem('user', JSON.stringify(user));
            setUser(user);
            setIsAuthenticated(true);
            return response.data;
        } catch (error) {
            setError(error.response?.data?.message || 'Login failed');
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        try {
            // await authApi.logout();
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            setUser(null);
            setIsAuthenticated(false);
        } catch (error) {
            setError('Logout failed');
        }
    };

    const hasRole = (requiredRole) => {
        if (requiredRole === 'doctor') {
            // return user?.roles?.includes(requiredRole);
            return user?.is_doctor;
        } else if (requiredRole === 'lab') {
            // return user?.roles?.includes(requiredRole);
            return user?.is_laboratory;
        } else if (requiredRole === 'vendor') {
            // return user?.roles?.includes(requiredRole);
            return user?.is_vendor;
        } else if (requiredRole === 'admin') {
            // return user?.roles?.includes(requiredRole);
            return user?.is_admin;
        } else if (requiredRole === 'logistics') {
            return user?.is_logistics;
        } else if (requiredRole === 'aht') {
            return user?.is_aht;
        } else {
            return false;
        }
    };

    // Get all roles the user has
    const getUserRoles = () => {
        if (!user) return [];
        
        const roles = [];
        
        // All authenticated users are farmers by default
        roles.push('farmer');
        
        if (user.is_doctor) roles.push('doctor');
        if (user.is_laboratory) roles.push('lab');
        if (user.is_vendor) roles.push('vendor');
        if (user.is_admin) roles.push('admin');
        if (user.is_logistics) roles.push('logistics');
        if (user.is_aht) roles.push('aht');
        
        return roles;
    };

    return (
        <AuthContext.Provider value={{
            user,
            isAuthenticated,
            loading,
            error,
            login,
            logout,
            hasRole,
            getUserRoles
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};